// This address points to a dummy ERC20 contract deployed on Ethereum Mainnet,
// Goerli, Kovan, Rinkeby and Ropsten. Replace it with your smart contracts.
const addresses = {
  //chemscriptsAddress: "0x82D492f4B24598C46b54359EfC725e738D77556D", //rinkeby
  chemscriptsAddress: "0xE895f87ea0F0eD1cD1ACA25500E623E9BDd28BD6", //mainnet
};

export default addresses;
